import React from "react";
import { Box, Card, CardContent, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

interface TargetDailyIntakeCardProps {
  targetDailyIntake?: number | null;
  mealPlanName?: string | null;
  loggedIntake?: number;
  showEmptyState?: boolean;
}

export const TargetDailyIntakeCard: React.FC<TargetDailyIntakeCardProps> = ({
  targetDailyIntake,
  mealPlanName,
  loggedIntake,
  showEmptyState = false,
}) => {
  return (
    <Card
      sx={{
        height: "100%",
        background: "#f8fafb",
        border: "1px solid #eaecf0",
        borderRadius: 0.75,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1, "&:last-child": { paddingBottom: 2 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, fontSize: 12, lineHeight: "16px" }}>
            Target Daily Intake
          </Typography>
          <Tooltip title="This is calculated from assigned meal plan">
            <InfoIcon sx={{ fontSize: 16, color: "text.secondary", cursor: "help" }} />
          </Tooltip>
        </Box>

        {showEmptyState ? (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4 }}>
            <Typography variant="h3" sx={{ fontSize: 20, lineHeight: "28px" }}>
              —
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="h3" sx={{ fontSize: 20, lineHeight: "28px" }}>
              {targetDailyIntake !== null && targetDailyIntake !== undefined ? `${Math.round(targetDailyIntake).toLocaleString()} kcal` : "—"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: "20px" }}>
              Meal plan: {mealPlanName || "—"} | Logged: {loggedIntake != null && loggedIntake > 0 ? `${Math.round(loggedIntake).toLocaleString()} kcal` : "—"}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
